module.exports = __webpack_public_path__ + "static/media/checkScope_3.27fee111.png";